module.exports = __webpack_public_path__ + "static/images/jf-coupon01.8dde635.png";